/* global document, window */

function formatOmnibusMoney(value, currency) {
  const amount = Number(value);

  if (!Number.isFinite(amount)) {
    return null;
  }

  const moneyFormat = window.themeJsData?.moneyWithCurrencyFormat;

  if (moneyFormat) {
    const [integerPart, decimalPart] = amount.toFixed(2).split('.');
    const withCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const withPeriods = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return moneyFormat
      .replace('{{amount}}', `${withCommas}.${decimalPart}`)
      .replace('{{amount_no_decimals}}', withCommas)
      .replace('{{amount_with_comma_separator}}', `${withPeriods},${decimalPart}`)
      .replace('{{amount_no_decimals_with_comma_separator}}', withPeriods);
  }

  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency}`.trim();
  }
}

function formatOmnibusWidgetPrices(widget) {
  const currency = widget.dataset.currency || '';
  const prices = [widget.dataset.lowest_price, widget.dataset.highest_price];

  prices.forEach((price) => {
    const amount = Number(price);
    const formattedPrice = formatOmnibusMoney(price, currency);

    if (!Number.isFinite(amount) || !formattedPrice) {
      return;
    }

    const appFormattedPrice = `${amount.toFixed(2)} ${currency}`.trim();

    widget.querySelectorAll('p').forEach((paragraph) => {
      paragraph.textContent = paragraph.textContent.replace(appFormattedPrice, formattedPrice);
    });
  });
}

window.updateOmnibusWidgetAll = function () {
  const source = document.getElementById('ow_omnibus_widget');

  if (!source) {
    return;
  }

  window?.updateOmnibusWidget?.();
  formatOmnibusWidgetPrices(source);

  const html = source ? source.innerHTML : '';

  document.querySelectorAll('.ow_omnibus_widget_clone').forEach((clone) => {
    clone.innerHTML = html;
  });
};

document.addEventListener('DOMContentLoaded', () => {
  window.updateOmnibusWidgetAll();
});

window.addEventListener('load', () => {
  window.updateOmnibusWidgetAll();
});
